<template>
	<section class="hero-section plans-hero-section">
		<div
			class="mx-auto max-w-7xl px-6 pb-[166px] md:pb-[280px] lg:pb-[420px] pt-24 sm:pt-32 lg:px-8"
		>
			<div
				class="flex flex-col lg:flex-row justify-center items-center text-center lg:text-left gap-x-24"
			>
				<div class="mb-4 lg:mb-0 lg:mr-12 flex-1 flex items-center">
					<h1
						class="gradient-title-white text-white text-[60px] lg:text-[64px] font-medium"
					>
						Welcome To StocksToTrade
					</h1>
				</div>
				<div class="flex-1 flex items-center">
					<p class="text-slate-100 text-xl lg:text-xl">
						StocksToTrade’s all-in-one trading platform helps traders to quickly
						analyze, and identify key trade setups without a hedge fund manager.
					</p>
				</div>
			</div>
		</div>
		<div class="flow-root bg-black pb-24 sm:pb-32">
			<div class="-mt-[190px] md:-mt-[305px] lg:-mt-[420px]">
				<div class="mx-auto max-w-7xl px-6 lg:px-8">
					<div class="flex justify-center">
						<img
							src="/images/about-page/big-about-img.webp"
							alt="Description"
							class="max-w-full h-auto rounded-3xl"
						/>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup></script>

<style lang="scss" scoped>
.plans-hero-section {
	background: linear-gradient(110deg, #091d56 8.05%, #331290 77.58%);
	position: relative;
	&::before {
		content: "";
		height: 100%;
		width: 100%;
		background:
			url("/images/hero-section-bg.avif"),
			lightgray 50%;
		position: absolute;
		left: 0;
		top: -124px;
		mix-blend-mode: overlay;
		opacity: 0.6;
		background-size: cover;
		background-repeat: no-repeat;
		transform: scale(1.5) translateX(16vw);
		z-index: 0;
		pointer-events: none;
	}

	.flow-root {
		position: relative;
		z-index: 1;

		> div {
			transform: translateY(80px);
		}
	}
}
</style>
